import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';



//Obtener los terceros
export async function fetchContacts({commit, state},requestParameters = {params: state.params_contacts}) {
    await $http.get('/api/terceros-lite', requestParameters)
        .then((response) => {
            commit('setContacts', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('contactError', error.message)
        })
}

// obtener Data libro Contable
export async function fetchAuxiliaryBookContact({commit, state}) {
    await $http.get('/api/libro-auxiliar-tercero', { params : state.params})
        .then((response) => {
            commit('setauxiliary_book', response.data.data);
            state.loading.module = false;
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: 'Error',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}


export async function getSubscriber({commit, dispatch, state}) {
    await $http.get(`/api/suscriptor`)
        .then(response => {
            commit('setSubscriber', response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
}



// WEBPACK FOOTER //
// ./src/modules/auxiliary-book-contact/actions.js